import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { createPageUrl } from '@/utils';
import { Button } from '@/components/ui/button';

/** admin個別機能ページ共通の背景・見出し・「機能一覧へ戻る」ボタン。 */
export default function AdminPageShell({
  icon: Icon,
  title,
  description,
  containerClassName = 'max-w-7xl',
  children,
}) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf6f1] via-[#f5ede3] to-[#efe5d8] text-[#2d1810] pb-20">
      <div className={`${containerClassName} mx-auto px-4 sm:px-6 lg:px-8 py-8`}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-8">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="mb-2 flex items-center gap-2 text-sm text-[#8b6f47]">
                <ShieldCheck className="h-4 w-4" />
                admin専用ページ
              </div>
              <h1 className="flex items-center gap-2 text-2xl font-bold text-[#2d1810] md:text-3xl">
                {Icon && <Icon className="h-6 w-6 flex-shrink-0 text-[#8b6f47]" />}
                {title}
              </h1>
              {description && <p className="mt-1 text-sm text-[#6b5540]">{description}</p>}
            </div>
            <Button
              asChild
              variant="outline"
              className="border-[#d4c4b0] text-[#5d4529] hover:bg-[#f5ede3]"
            >
              <Link to={createPageUrl('AdminIndex')}>admin機能一覧へ戻る</Link>
            </Button>
          </div>
        </motion.div>

        {children}
      </div>
    </div>
  );
}
